<footer class="l-footer">
    <div class="u-block">
      <div class="p-footer-bottom">
        <p class="p-footer-copyright"><small>©2023 Manulife Life Insurance Company.</small></p>
      </div>
    </div>
  <!-- /l-footer --></footer>